(() => {
  const ui = { empty: 'Your room is a blank canvas. Use a heart on a product to start collecting ideas.', remove: 'Remove', saved: 'Added to your room board', removed: 'Removed from your room board', product: 'product', products: 'products' };
  function readUI() {
    try {
      const strings = JSON.parse(document.querySelector('#dc-ui-strings')?.textContent || '{}');
      Object.keys(ui).forEach(key => { if (typeof strings[key] === 'string' && strings[key].trim()) ui[key] = strings[key]; });
    } catch {}
  }
  function cleanProduct(product) {
    if (!product || typeof product !== 'object' || typeof product.handle !== 'string' || typeof product.title !== 'string' || typeof product.url !== 'string') return null;
    const handle = product.handle.trim();
    const title = product.title.trim().slice(0, 300);
    if (!/^[a-z0-9][a-z0-9-]{0,254}$/i.test(handle) || !title || product.url.length > 2000) return null;
    try {
      const url = new URL(product.url, window.location.origin);
      const path = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/i);
      if (url.origin !== window.location.origin || !path || decodeURIComponent(path[1]) !== handle) return null;
      return { handle, title, url: url.pathname };
    } catch { return null; }
  }
  let saved = [];
  try {
    const stored = localStorage.getItem('dencrest-room-board-v1') || '[]';
    const products = stored.length <= 300000 ? JSON.parse(stored) : [];
    if (Array.isArray(products)) {
      const seen = new Set();
      saved = products.map(cleanProduct).filter(product => {
        if (!product || seen.has(product.handle)) return false;
        seen.add(product.handle);
        return true;
      }).slice(-100);
    }
  } catch {}
  const heart = active => `<svg class="dc-icon dc-heart" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="${active ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>`;
  function updateBoard() {
    document.querySelectorAll('#board-count').forEach(el => el.textContent = saved.length);
    document.querySelectorAll('[data-save]').forEach(el => { const active = saved.some(p => p.handle === el.dataset.save); el.setAttribute('aria-pressed', String(active)); el.innerHTML = heart(active); });
    const list = document.querySelector('#board-items');
    if (!list) return;
    const content = document.createDocumentFragment();
    saved.forEach(product => {
      const row = document.createElement('div'); row.className = 'board-row';
      const link = document.createElement('a'); link.href = product.url; link.textContent = product.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.remove = product.handle; remove.textContent = ui.remove; remove.setAttribute('aria-label', `${ui.remove} ${product.title}`);
      row.append(link, remove); content.append(row);
    });
    if (!saved.length) { const empty = document.createElement('p'); empty.className = 'board-empty'; empty.textContent = ui.empty; content.append(empty); }
    list.replaceChildren(content);
  }
  function persist() { try { localStorage.setItem('dencrest-room-board-v1', JSON.stringify(saved)); } catch {} updateBoard(); }
  function closeMenu(root, restoreFocus = false) {
    const menu = root.querySelector('#mobile-menu');
    const nav = root.querySelector('nav');
    if (!menu || !nav) return;
    const wasOpen = nav.classList.contains('open');
    nav.classList.remove('open'); menu.setAttribute('aria-expanded', 'false');
    if (restoreFocus && wasOpen) menu.focus();
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.dc-header').forEach(root => { if (!root.contains(event.target)) closeMenu(root); });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || document.querySelector('dialog[open]')) return;
    document.querySelectorAll('.dc-header').forEach(root => closeMenu(root, true));
  });
  function init() {
    readUI();
    document.querySelectorAll('.dc').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const menu = root.querySelector('#mobile-menu');
      const nav = root.querySelector('nav');
      if (menu && nav) { nav.id ||= menu.getAttribute('aria-controls') || 'dc-main-navigation'; menu.setAttribute('aria-controls', nav.id); }
      root.addEventListener('click', event => {
        const target = event.target.closest('button,a'); if (!target) return;
        if (target.matches('#board-open,#footer-board')) { updateBoard(); document.querySelector('#board-dialog')?.showModal(); }
        if (target.matches('.dialog-close')) target.closest('dialog').close();
        if (target.matches('[data-remove]')) {
          const index = saved.findIndex(p => p.handle === target.dataset.remove);
          saved = saved.filter(p => p.handle !== target.dataset.remove); persist();
          const buttons = document.querySelectorAll('#board-items [data-remove]');
          (buttons[Math.min(index, buttons.length - 1)] || document.querySelector('#board-dialog .dialog-close'))?.focus();
        }
        if (target.matches('[data-save]')) {
          const card = target.closest('.dc-product');
          const product = cleanProduct(card ? { handle: card.dataset.handle, title: card.dataset.title, url: card.dataset.url } : null);
          if (!product) return;
          const exists = saved.some(p => p.handle === product.handle);
          saved = exists ? saved.filter(p => p.handle !== product.handle) : [...saved, product].slice(-100);
          persist(); const toast = document.querySelector('#toast'); if (toast) { toast.textContent = exists ? ui.removed : ui.saved; toast.classList.add('visible'); clearTimeout(toast._timer); toast._timer = setTimeout(() => toast.classList.remove('visible'), 2200); }
        }
        if (target.id === 'mobile-menu' && nav) target.setAttribute('aria-expanded', String(nav.classList.toggle('open')));
        if (target.closest('nav')) closeMenu(root);
      });
      root.querySelectorAll('dialog').forEach(d => d.addEventListener('click', e => { if(e.target === d) { const r = d.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); } }));
    });
    document.querySelectorAll('[data-dc-home]').forEach(root => {
      if (root.dataset.homeInitialized) return; root.dataset.homeInitialized = 'true';
      const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
      const images = JSON.parse($('#dc-room-images').textContent);
      let room = 'pool';
      const firstScene = { image: images.hero, title: $('#hero-title').innerHTML, description: $('#hero-description').innerHTML, label: $('#hero-label').textContent, alt: $('#hero-image').alt };
      const scenes = [firstScene, { image: images.arcade, title: 'ONE MORE<br><em>GAME.</em>', description: 'The classics you grew up with.<br>A space you’ve grown into. Let the good times replay.', label: '02 — The after-hours arcade', alt: 'Retro arcade lounge with warm wood and forest green walls' }, { image: images.cinema, title: 'LIGHTS DOWN.<br><em>WORLD OFF.</em>', description: 'A bigger picture. A deeper escape.<br>Your favorite seat is waiting at home.', label: '03 — The private cinema', alt: 'Private home cinema with leather seating and a projection screen' }];
      const rooms = { pool: ['THE CLASSIC, RECONSIDERED', 'A room with a little rivalry.', 'A warm pool room with a home bar'], arcade: ['FOR YOUR INNER HIGH-SCORE CHASER', 'Nostalgia. With a new address.', 'Arcade cabinets in a forest green lounge'], cinema: ['THE OUTSIDE WORLD CAN WAIT', 'Every seat is the best seat.', 'Leather seating in a private home cinema'] };
      let activeFilter = 'all', expanded = false;
      function renderProducts() {
        const cards = $$('.dc-product');
        const matching = cards.filter(c => activeFilter === 'all' || c.dataset.category === activeFilter);
        const columns = getComputedStyle($('#product-grid')).gridTemplateColumns.split(' ').length;
        cards.forEach(c => c.hidden = !matching.includes(c) || (!expanded && matching.indexOf(c) >= columns));
        $('#product-grid').dataset.ready = 'true';
        $('#product-count').textContent = `${matching.length} ${matching.length === 1 ? ui.product : ui.products}`;
        const more = $('#dc-view-more');
        more.hidden = matching.length <= columns;
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? more.dataset.less : more.dataset.more;
      }
      function filter(key) {
        activeFilter = key; expanded = false;
        $$('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === key)));
        renderProducts();
      }
      window.addEventListener('resize', () => { if(root.isConnected) renderProducts(); });
      function chooseRoom(key) { room = key; $('#room-image').src = images[key]; $('#room-image').alt = rooms[key][2]; $('#room-kicker').textContent = rooms[key][0]; $('#room-title').textContent = rooms[key][1]; $$('[data-room]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.room === key))); }
      root.addEventListener('click', e => {
        const b = e.target.closest('button,a'); if (!b) return;
        if (b.dataset.filter) filter(b.dataset.filter);
        if (b.id === 'dc-view-more') { expanded = !expanded; renderProducts(); if (!expanded) $('#products').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        if (b.dataset.categoryLink) filter(b.dataset.categoryLink);
        if (b.dataset.room) chooseRoom(b.dataset.room);
        if (b.dataset.scene) { const scene = scenes[Number(b.dataset.scene)]; $('#hero-image').src = scene.image; $('#hero-image').alt = scene.alt; $('#hero-title').innerHTML = scene.title; $('#hero-description').innerHTML = scene.description; $('#hero-label').textContent = scene.label; $$('[data-scene]').forEach(other => other.setAttribute('aria-pressed', String(other === b))); }
        if (b.id === 'room-shop') { filter(room); $('#products').scrollIntoView({ behavior: 'smooth' }); }
        if (b.id === 'finder-open') $('#finder-dialog').showModal();
        if (b.dataset.find) { $('#finder-dialog').close(); chooseRoom(b.dataset.find); $('#inspiration').scrollIntoView({ behavior: 'smooth' }); }
      });
      for (const selector of ['[data-room]', '[data-scene]', '[data-filter]']) { const buttons = $$(selector); buttons.forEach((b,i) => b.addEventListener('keydown', e => { if (!['ArrowLeft','ArrowRight'].includes(e.key)) return; e.preventDefault(); const n = buttons[(i + (e.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length]; n.focus(); n.click(); })); }
      filter('all');
    });
    updateBoard();
  }
  document.addEventListener('shopify:section:load', init);
  init();
})();

// Use the same drawn arrows on all operating systems, including mobile.
(() => {
  const paths = {
    '↗': 'M5 19 19 5M5 5h14v14',
    '→': 'M3 12h18M14 5l7 7-7 7',
    '↓': 'M12 3v18M5 14l7 7 7-7',
    '↻': 'M20 7v5h-5M20 12a8 8 0 1 0-2.3 5.7'
  };
  const pattern = /[↗→↓↻]/;
  function normalize(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (pattern.test(node.data) && !node.parentElement.closest('script,style,svg,textarea,select,[contenteditable]')) nodes.push(node);
    }
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.data.split(/([↗→↓↻])/).forEach(part => {
        if (!paths[part]) { fragment.append(document.createTextNode(part)); return; }
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'dc-arrow');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', paths[part]);
        svg.append(path); fragment.append(svg);
      });
      node.replaceWith(fragment);
    });
  }
  const observers = new WeakMap();
  function initArrows() {
    document.querySelectorAll('.dc').forEach(root => {
      normalize(root);
      if (observers.has(root)) return;
      const observer = new MutationObserver(() => {
        observer.disconnect(); normalize(root);
        observer.observe(root, { childList: true, subtree: true, characterData: true });
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      observers.set(root, observer);
    });
  }
  initArrows();
  document.addEventListener('shopify:section:load', initArrows);
})();





// Match the original storefront's cubic-eased, once-per-view count-up.
(() => {
  function initCounters() {
    document.querySelectorAll('[data-dc-count-heading]').forEach(heading => {
      if (heading.dataset.counterReady) return;
      heading.dataset.counterReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      let target;
      while (walker.nextNode()) { if (/\b30\b/.test(walker.currentNode.data)) { target = walker.currentNode; break; } }
      if (!target) return;
      const original = target.data;
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = '30';
      const position = original.indexOf('30');
      heading.setAttribute('aria-label', heading.textContent.trim());
      target.replaceWith(document.createTextNode(original.slice(0, position)), number, document.createTextNode(original.slice(position + 2)));
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        let start;
        function tick(time) {
          start ??= time;
          const progress = Math.min((time - start) / 2000, 1);
          number.textContent = String(Math.round(30 * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.35 });
      observer.observe(heading);
    });
  }
  initCounters();
  document.addEventListener('shopify:section:load', initCounters);
})();


(() => {
 function initReturningHeader() {
  document.querySelectorAll('.dc-header:not(.dc-returning-header)').forEach(root => {
   const header=root.querySelector('header'); if(!header) return;
   root.classList.add('dc-returning-header');
   let previous=Math.max(0,window.scrollY), timer;
   const measure=()=>{root.style.minHeight=(header.offsetHeight+(root.querySelector('.announcement')?.offsetHeight||0))+'px';};
   const cancel=()=>{clearTimeout(timer);timer=null;};
   const scroll=()=>{
    if(!root.isConnected){cancel();window.removeEventListener('scroll',scroll);return;}
    const y=Math.max(0,window.scrollY), delta=y-previous;
    if(y<=root.offsetTop+root.offsetHeight){cancel();root.classList.remove('is-detached','is-revealed');}
    else {
     root.classList.add('is-detached');
     if(delta>2&&!header.contains(document.activeElement)&&!root.querySelector('nav.open')){cancel();root.classList.remove('is-revealed');}
     else if(delta< -2&&!timer&&!root.classList.contains('is-revealed')) timer=setTimeout(()=>{root.classList.add('is-revealed');timer=null;},1000);
    }
    previous=y;
   };
   header.addEventListener('focusin',()=>{cancel();root.classList.add('is-revealed');});
   new ResizeObserver(measure).observe(header); measure();
   window.addEventListener('scroll',scroll,{passive:true}); scroll();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReturningHeader);else initReturningHeader();
 document.addEventListener('shopify:section:load',initReturningHeader);
})();
